<div class="d-flex justify-content-start justify-content-md-end flex-wrap">
    <div class="btn-group dropdown mr-3 mb-3" dropdown container="body" *ngIf="showStatusFilter">
        <button class="btn btn-default btn-inverted" dropdownToggle>
            {{ l("AllocationStatus") }}
        </button>
        <ul class="dropdown-menu" *dropdownMenu>
            <li *ngFor="let enum of allocationStatuses">
                <button
                    (click)="setStatusFilter(enum.value)"
                    class="dropdown-item btn-primary"
                >
                    {{ l(enum.key) }}
                </button>
            </li>
        </ul>
    </div>
    <div class="btn-group dropdown mr-3 mb-3" dropdown container="body" *ngIf="showFormStatusFilter">
        <button class="btn btn-default btn-inverted" dropdownToggle>
            {{ l("FormStatus") }}
        </button>
        <ul class="dropdown-menu" *dropdownMenu>
            <li *ngFor="let status of formStatuses">
                <button
                    (click)="setFormStatus(status.value)"
                    class="dropdown-item btn-primary"
                >
                    {{ l(status.text) }}
                </button>
            </li>
        </ul>
    </div>
    <div class="btn-group dropdown mr-3 mb-3" dropdown container="body" *ngIf="showAllocationStatusFilter">
        <button class="btn btn-default btn-inverted" dropdownToggle>
            {{ l("AllocationStatus") }}
        </button>
        <ul class="dropdown-menu" *dropdownMenu>
            <li *ngFor="let status of allocationSheetStatuses">
                <button
                    (click)="setAllocationSheetStatus(status.value)"
                    class="dropdown-item btn-primary"
                >
                    {{ l(status.text) }}
                </button>
            </li>
        </ul>
    </div>
    <div class="mr-3 mb-3">
        <button
            class="btn btn-default btn-inverted"
            (click)="creatorSelector.open()"
        >
            {{ l("SelectCreator") }}
        </button>

        <div style="opacity: 0; pointer-events: none; height: 0px; width: 1px">
            <mat-form-field>
                <mat-select
                    [formControl]="creatorFormCtrl"
                    [multiple]="true"
                    #creatorSelector
                >
                    <mat-option>
                        <ngx-mat-select-search
                            noEntriesFoundLabel="No results found"
                            placeholderLabel="Find a creator..."
                            [formControl]="creatorFilterFormCtrl"
                        >
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option
                        *ngFor="let creator of filteredCreator | async"
                        [value]="creator"
                        (click)="refresh()"
                    >
                        {{ creator.firstName }} {{ creator.lastName }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="mr-3 mb-3" *ngIf="assignedSupervisorForForemanFilter">
        <button
            class="btn btn-default btn-inverted"
            (click)="assignedSupervisorSelector.open()"
        >
            {{ l("AssignedSupervisor") }}
        </button>

        <div style="opacity: 0; pointer-events: none; height: 0px; width: 1px">
            <mat-form-field>
                <mat-select
                    [formControl]="assignedSupervisorFormCtrl"
                    [multiple]="true"
                    #assignedSupervisorSelector
                >
                    <mat-option>
                        <ngx-mat-select-search
                            noEntriesFoundLabel="No results found"
                            placeholderLabel="Find a supervisor..."
                            [formControl]="assignedSupervisorFilterFormCtrl"
                        >
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option
                        *ngFor="let supervisor of filteredAssignedSupervisor | async"
                        [value]="supervisor"
                        (click)="refresh()"
                    >
                        {{ supervisor.contactDetails.emailAddress }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="mr-3 mb-3" *ngIf="showAssetFilter">
        <button
            class="btn btn-default btn-inverted"
            (click)="assetSelector.open()"
        >
            {{ l("Asset") }}
        </button>

        <div style="opacity: 0; pointer-events: none; height: 0px; width: 1px">
            <mat-form-field>
                <mat-select
                    [formControl]="assetFormCtrl"
                    [multiple]="false"
                    #assetSelector
                >
                    <mat-option>
                        <ngx-mat-select-search
                            noEntriesFoundLabel="No results found"
                            placeholderLabel="Find a asset..."
                            [formControl]="assetFilterFormCtrl"
                        >
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option
                        *ngFor="let asset of filteredAsset | async"
                        [value]="asset"
                        (click)="loadControlling(asset, option)"
                        #option
                    >
                        {{ asset.assetCode }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div *ngIf="showControlAccountFilter">
        <button
            class="btn btn-default btn-inverted"
            [disabled]="!assetFormCtrl.value"
            (click)="controllingSelector.open()"
        >
            {{ l("ControllingAccount") }}
        </button>
        <div style="opacity: 0; pointer-events: none; height: 0px; width: 1px">
            <mat-form-field>
                <mat-select
                    [formControl]="controllingFormCtrl"
                    [multiple]="true"
                    #controllingSelector
                >
                    <mat-option>
                        <ngx-mat-select-search
                            noEntriesFoundLabel="No results found"
                            placeholderLabel="Find a control account..."
                            [formControl]="controllingFilterFormCtrl"
                        >
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option
                        *ngFor="let control of filteredControlling | async"
                        [value]="control"
                        (click)="refresh()"
                    >
                        {{ control.controllingAccountAccId }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="btn-group dropdown mr-3 mb-3" dropdown container="body" *ngIf="showFormTypeFilter">
        <button class="btn btn-default btn-inverted" dropdownToggle>
            {{ l("FormType") }}
        </button>
        <ul class="dropdown-menu" *dropdownMenu>
            <li>
                <button
                    (click)="setFormTypeFilter('Allocation')"
                    class="dropdown-item btn-primary"
                >
                    {{ l("AllocationActivity") }}
                </button>
            </li>
            <li>
                <button
                    (click)="setFormTypeFilter('Forms')"
                    class="dropdown-item btn-primary"
                >
                    {{ l("CustomForms") }}
                </button>
            </li>
        </ul>
    </div>

    <!-- CLEAR ALL FILTER -->
    <div class="mb-3">
        <button
            title="{{ l('ResetFilters') }}"
            class="btn btn-default"
            (click)="clearFilters()"
        >
            <i class="fa fa-redo"></i>
        </button>
    </div>
</div>
